<script lang="ts">
	import { createEventDispatcher, onMount } from "svelte";

	const dispatch = createEventDispatcher();

	const elements = [
		`<circle r="3" />`,
		`<rect width="4" height="4" x="-2" y="-2" />`,
		`<path d="M -5 5 L 0 -5 L 5 5 Z" />`,
	];

	const colors = [
		"#fff",
		"#c7ecee",
		"#778beb",
		"#f7d794",
		"#63cdda",
		"#cf6a87",
		"#e77f67",
		"#786fa6",
		"#FDA7DF",
		"#4b7bec",
		"#475c83",
	];

	const arrayRandom = ( arr ) => arr[ Math.floor( Math.random() * arr.length ) ];

	const particles = new Array( 100 ).fill( 0 ).map( ( _, i ) => ({
		scale: Math.random() * 2 + 0.5,
		rotation: Math.random() * 360,
		duration: 3 + Math.random() * 0.5,
		delay: Math.random() * 0.5,
		color: arrayRandom( colors ),
		element: arrayRandom( elements ),
		x: Math.random() * 100,
	}) );

	setTimeout( () => dispatch( 'done' ), 4500 );
</script>

<svg class="confetti-layer">
	{#each particles as { scale, rotation, duration, delay, color, element, x } }
		<g style="transform: translate( {x}%, -10% ) scale({scale}); --rotation: {rotation}deg">
			<g
				fill={color}
				style={[
					`animation-delay: ${delay}s`,
					`animation-duration: ${duration}s`,
				].join(';')}
			>
				{@html element}
			</g>
		</g>
	{/each}
</svg>

<style>
	.confetti-layer {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		pointer-events: none;
	}

	@keyframes float {
		0% {
			transform: translateY( 0% ) rotate( 0deg );
			opacity: 1;
		}

		80% {
			transform: translateY( 80% ) rotate( 288deg );
			opacity: 1;
		}

		100% {
			transform: translateY( 100% ) rotate( 360deg );
			opacity: 0;
		}
	}

	svg > g > g {
		animation: float 2s linear;
	}
</style>